/**
 *  사용자 네비게이션 메뉴
 *
 *  @author 2024        김효민
 *  @author 2026-04-23  Bruce.Cheong    (디자인 개선)
 *
 */

/** Internal import */
import Navi from "./Navi";

import { ReactComponent as IconHome}        from    "./Navi/icon/home.svg";
import { ReactComponent as IconSchedule}    from    "./Navi/icon/schedule.svg";
import { ReactComponent as IconPicture}     from    "./Navi/icon/picture.svg";
import { ReactComponent as IconProduct}     from    "./Navi/icon/product.svg";
import { ReactComponent as IconTheme}       from    "./Navi/icon/theme.svg";
import { ReactComponent as IconContract}    from    "./Navi/icon/contract.svg";
import { ReactComponent as IconMypage}      from    "./Navi/icon/mypage.svg";

import { NaviItemType } from "./interface/Navi.interface";

const naviItemList: NaviItemType[] = [
    // {
    //     name: "홈",
    //     icon: IconHome,
    //     navigate: "/",
    // },
    {
        name: "홈",
        icon: IconHome,
        navigate: "/myHome",
    },
    {
        name: "촬영 일정",
        icon: IconSchedule,
        navigate: "/reservationHome",
    },
    {
        name: "내 사진",
        icon: IconPicture,
        navigate: "/photoList",
    },
    {
        name: "제품 신청",
        icon: IconProduct,
        navigate: "/productList",
    },
    {
        name: "촬영 테마",
        icon: IconTheme,
        navigate: "/themeBook",
    },
    // {
    //     name: "계약",
    //     icon: IconContract,
    //     navigate: "/paymentHistory",
    // },
    {
        name: "마이페이지",
        icon: IconMypage,
        navigate: "/myPage",
    },
];

const CustomerNavi = () => {
    return(
        <Navi
            navi_item_list={naviItemList}
        />
    )
}

export default CustomerNavi;
